export default __webpack_public_path__ + "static/media/expand.5dfd6da4.svg";